import {
    ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_SUCCESS,
    ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_FAILED,
    LOADING_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE,
    NETWORK_ERROR_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminAccountTypeMappingDelete =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE });
        await adminServices
            .post("deleteaccTypeMapping", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: ADMIN_ACCOUNT_TYPE_MAPPING_DELETE_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_ADMIN_ACCOUNT_TYPE_MAPPING_DELETE,
                    payload: err
                });
            });
    };

export { adminAccountTypeMappingDelete };
